// @ts-nocheck
export const localeCodes =  [
  "en-int",
  "en-emea",
  "en-jp",
  "en-tw",
  "en-kr",
  "en-americas",
  "en-asia-pacific",
  "ja-jp",
  "zh-cn",
  "zh-tw"
]
export const localeLoaders = {
  "en-int": [
    {
      key: "locale_en_45int_46json_da52bd12",
      load: () => import("#nuxt-i18n/da52bd12" /* webpackChunkName: "locale_en_45int_46json_da52bd12" */),
      cache: true
    }
  ],
  "en-emea": [
    {
      key: "locale_en_45emea_46json_951a1b00",
      load: () => import("#nuxt-i18n/951a1b00" /* webpackChunkName: "locale_en_45emea_46json_951a1b00" */),
      cache: true
    }
  ],
  "en-jp": [
    {
      key: "locale_en_45jp_46json_97a94ab5",
      load: () => import("#nuxt-i18n/97a94ab5" /* webpackChunkName: "locale_en_45jp_46json_97a94ab5" */),
      cache: true
    }
  ],
  "en-tw": [
    {
      key: "locale_en_45tw_46json_f37ce9b3",
      load: () => import("#nuxt-i18n/f37ce9b3" /* webpackChunkName: "locale_en_45tw_46json_f37ce9b3" */),
      cache: true
    }
  ],
  "en-kr": [
    {
      key: "locale_en_45kr_46json_cad686e7",
      load: () => import("#nuxt-i18n/cad686e7" /* webpackChunkName: "locale_en_45kr_46json_cad686e7" */),
      cache: true
    }
  ],
  "en-americas": [
    {
      key: "locale_en_45americas_46json_1e84d832",
      load: () => import("#nuxt-i18n/1e84d832" /* webpackChunkName: "locale_en_45americas_46json_1e84d832" */),
      cache: true
    }
  ],
  "en-asia-pacific": [
    {
      key: "locale_en_45asia_45pacific_46json_3410c589",
      load: () => import("#nuxt-i18n/3410c589" /* webpackChunkName: "locale_en_45asia_45pacific_46json_3410c589" */),
      cache: true
    }
  ],
  "ja-jp": [
    {
      key: "locale_ja_45jp_46json_29520dd7",
      load: () => import("#nuxt-i18n/29520dd7" /* webpackChunkName: "locale_ja_45jp_46json_29520dd7" */),
      cache: true
    }
  ],
  "zh-cn": [
    {
      key: "locale_zh_45cn_46json_927d5db1",
      load: () => import("#nuxt-i18n/927d5db1" /* webpackChunkName: "locale_zh_45cn_46json_927d5db1" */),
      cache: true
    }
  ],
  "zh-tw": [
    {
      key: "locale_zh_45tw_46json_d1e3d806",
      load: () => import("#nuxt-i18n/d1e3d806" /* webpackChunkName: "locale_zh_45tw_46json_d1e3d806" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en-int",
    language: "en-int",
    _hreflang: "en-int",
    _sitemap: "en-int"
  },
  {
    code: "en-emea",
    language: "en-emea",
    _hreflang: "en-emea",
    _sitemap: "en-emea"
  },
  {
    code: "en-jp",
    language: "en-jp",
    _hreflang: "en-jp",
    _sitemap: "en-jp"
  },
  {
    code: "en-tw",
    language: "en-tw",
    _hreflang: "en-tw",
    _sitemap: "en-tw"
  },
  {
    code: "en-kr",
    language: "en-kr",
    _hreflang: "en-kr",
    _sitemap: "en-kr"
  },
  {
    code: "en-americas",
    language: "en-americas",
    _hreflang: "en-americas",
    _sitemap: "en-americas"
  },
  {
    code: "en-asia-pacific",
    language: "en-asia-pacific",
    _hreflang: "en-asia-pacific",
    _sitemap: "en-asia-pacific"
  },
  {
    code: "ja-jp",
    language: "ja-jp",
    _hreflang: "ja-jp",
    _sitemap: "ja-jp"
  },
  {
    code: "zh-cn",
    language: "zh-cn",
    _hreflang: "zh-cn",
    _sitemap: "zh-cn"
  },
  {
    code: "zh-tw",
    language: "zh-tw",
    _hreflang: "zh-tw",
    _sitemap: "zh-tw"
  }
]
/** client **/

/** client-end **/